export default "/kiban/_next/static/images/31_10L_none-93c2496480d20458021a37234e27b1d3.png";